const sendTrackingEvent = (params) => {
  try {
    dataLayer?.push(params);
  } catch (error) {
    // tracking error
  }
};

export { sendTrackingEvent };
